import React, { useState } from "react";
import styles from "./MarkUpSettings.module.scss";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import AgentSideBar from "../../CustomComponents/Property/SideBar/SideBar";
import Loader from "../../CustomComponents/Loader/Loader";

const markupOptions = [
  {
    title: "Set price markup for Flights - per pax (excluding infant) per trip",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#000"
      >
        <path d="M280-80v-100l120-84v-144L80-280v-120l320-224v-176q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800v176l320 224v120L560-408v144l120 84v100l-200-60-200 60Z" />
      </svg>
    ),
    sections: [{ label: "Domestic Flight" }, { label: "International Flight" }],
  },
  {
    title: "Set price markup for Hotels",
    sections: [{ label: "Domestic Hotel" }, { label: "International Hotel" }],
  },
];

const MarkUpSettings = () => {
  const [markupType, setMarkupType] = useState({});
  const [editMode, setEditMode] = useState({});
  const [amounts, setAmounts] = useState({});
  const [loader, setLoader] = useState(false);

  const handleChange = (sectionLabel, type) => {
    setMarkupType((prev) => ({ ...prev, [sectionLabel]: type }));
  };

  const handleEditToggle = (sectionLabel) => {
    setEditMode((prev) => ({
      ...prev,
      [sectionLabel]: !prev[sectionLabel],
    }));
  };

  const handleAmountChange = (sectionLabel, value) => {
    const selectedType = markupType[sectionLabel];
    const numericValue = parseFloat(value);

    if (selectedType === "percentage" && numericValue > 100) {
      return; // Prevent value above 100%
    }

    setAmounts((prev) => ({
      ...prev,
      [sectionLabel]: value,
    }));
  };

  return (
    <div id="Listingholidays">
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} />
          <section className="w-full">
            <div id="common_background_profile m_20">
              {loader ? (
                <Loader size="4em" color="#009A50" />
              ) : (
                <div>
                  <div className={styles.wrapper}>
                    <h1 className={styles.heading}>Markup Settings</h1>
                    <p className={styles.description}>
                      Use absolute markup to add a flat markup to the total
                      price and percentage markup to add a percentage markup to
                      the total price. This markup will not apply to the booking
                      amount at the time of booking.
                    </p>

                    {markupOptions.map((group, idx) => (
                      <div key={idx} className={styles.markupGroup}>
                        <h4 className={styles.groupTitle}>
                          {group.icon ? (
                            <span className={styles.icon}>{group.icon}</span>
                          ) : null}
                          {group.title}
                        </h4>

                        {group.sections.map((section) => {
                          const isEditing = !!editMode[section.label];
                          return (
                            <div key={section.label} className={styles.section}>
                              <strong>{section.label}</strong>
                              <div className={styles.row}>
                                <label className={styles.label}>
                                  Add Markup as
                                </label>
                                <label className={styles.radioLabel}>
                                  <input
                                    type="radio"
                                    name={section.label}
                                    value="absolute"
                                    checked={
                                      markupType[section.label] !== "percentage"
                                    }
                                    onChange={() =>
                                      handleChange(section.label, "absolute")
                                    }
                                    disabled={!isEditing}
                                  />
                                  <span>Absolute (₹)</span>
                                </label>
                                <label className={styles.radioLabel}>
                                  <input
                                    type="radio"
                                    name={section.label}
                                    value="percentage"
                                    checked={
                                      markupType[section.label] === "percentage"
                                    }
                                    onChange={() =>
                                      handleChange(section.label, "percentage")
                                    }
                                    disabled={!isEditing}
                                  />
                                  <span>Percentage (%)</span>
                                </label>

                                <label className={styles.label}>
                                  Markup Amount
                                </label>
                                <div className={styles.inputGroup}>
                                  <span className={styles.currency}>₹</span>
                                  <input
                                    type="number"
                                    placeholder="Enter markup amount"
                                    className={styles.input}
                                    value={amounts[section.label] || ""}
                                    disabled={!isEditing}
                                    onChange={(e) =>
                                      handleAmountChange(
                                        section.label,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                <button
                                  className={styles.editBtn}
                                  onClick={() =>
                                    handleEditToggle(section.label)
                                  }
                                >
                                  {isEditing ? "Save" : "Edit"}
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MarkUpSettings;
